<div *ngIf="stripeStatus == ''">

    <!-- SPINNER MIENTRAS CARGA -->
    <div *ngIf="loaded == 1">

        <!-- RESUMEN DE LA COMPRA -> CONTINUAR CON LA COMPRA -->

        <section *ngIf="usuarioLoggeado == 1" class="100vh" fxLayoutAlign="center center">

            <div class="cw">

                <!-- Regresar -->
                <a (click)="goBack()" class="grayLink ft15">
                    <div fxLayoutAlign=" center" class="mgb05">
                        <mat-icon class="ft20 linkIcon grayLink"> arrow_back </mat-icon>
                        <span class="ft400 ft15 grayLink ft500">Regresar</span>
                    </div>
                </a>
                <br>

                <!-- Contenedor de info del curso -->
                <div class="border radius3 pd10">

                    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between">
                        <div>
                            <h6 class="ft ft15 gray-6">Comprar curso</h6>
                            <h6 class="ft500 ft17">{{curso.titulo}}</h6>
                            <p>Instructor: {{curso.instructorNombre}}</p>
                            <p> Ofrecido por: {{curso.empresaNombre}}</p>
                            <p *ngIf="curso.porcentajeDescuento >= 0">Precio original: {{curso.precioOriginal}} USD</p>
                            <p *ngIf="curso.porcentajeDescuento >= 0">Descuento: {{curso.porcentajeDescuento}}%</p>
                            <p class="mgt05 gray-9 ft500">Precio final: {{curso.precioFinal}} USD</p>
                            <button (click)="checkoutFirebase(this.id); loaded=0" class="mgt10 darkButton">Continuar a
                                la compra</button>
                        </div>
                        <div>
                            <img [src]=curso.foto ngClass.gt-sm="imgCurso border radius3 " ngClass.lt-md="mgt10 fw border radius3 ">
                        </div>

                    </div>
                </div>

            </div>
        </section>

    </div>

    <!-- Muestra spinner cuando hacemos click en el boton de comprar ya que debemos esperar un corto delay de la Cloud Function -->
    <div *ngIf="loaded == 0">
        <div *ssrExclude>
            <spinner></spinner>
        </div>
    </div>

</div>

<div *ngIf="stripeStatus == 'success' || stripeStatus == 'cancel'" class="fullScreenCenterCenter">

    <!-- Exito en la compra -->
    <div *ngIf="stripeStatus == 'success'" fxLayout="column" fxLayoutAlign="center center">
        <h3 class="centertext">¡Enhorabuena!</h3>
        <h5 class="centertext gray-7">Gracias por su compra</h5>
        <button routerLink="/est/mis-cursos" class="mgt10 darkButton">Ir a mis cursos</button>
    </div>

    <!-- transaccion fallida -->
    <div *ngIf="stripeStatus == 'cancel'" fxLayout="column" fxLayoutAlign="center center">
        <h3 class="centertext">Trasacción cancelada</h3>
        <button routerLink="/buscar" class="mgt10 darkButton">Explorar cursos</button>
    </div>

</div>